import React from 'react';
import {StoreContextProvider} from 'src/context/storeContext';
import 'intersection-observer';

export const wrapRootElement = ({element}) => (
	<StoreContextProvider>{element}</StoreContextProvider>
);

if (window.ga) {
	window.ga('require', 'linker');
	window.ga('linker:autoLink', [
		'ericaweiner.com',
		'checkout.ericaweiner.com',
		'erica-weiner.myshopify.com',
	]);
}

export const shouldUpdateScroll = ({routerProps, getSavedScrollPosition}) => {
	// if filtering collections don't scroll to top
	if (routerProps.location.state?.shouldUpdateScroll === false) {
		return false;
	} else {
		const savedPosition = getSavedScrollPosition(routerProps.location);
		window.scrollTo(...(savedPosition || [0, 0]));
	}

	// return false;
};
